import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import asLogoWhite from '../../assets/img/as-logo-white.svg';
import supportIcon from '../../assets/img/support.svg';
import { logout } from '../../services/api/AuthService';
import '../../styles/Header.css';

  const MOBILE_BREAKPOINT = 768;
  const MENU_CLOSE_DELAY = 200;
  const Header = ({ onMenuToggle, menuItems = [] }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [userType, setUserType] = useState('');
  const [userInfo, setUserInfo] = useState({});
  const [supportMenuOpen, setSupportMenuOpen] = useState(false);
  const supportMenuRef = useRef(null);
  const closeTimerRef = useRef(null);

  useEffect(() => {
    const savedUserType = localStorage.getItem('userType');
    setUserType(savedUserType || '');
    const info = localStorage.getItem('userInfo');
    setUserInfo(info ? JSON.parse(info) : {});
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
    const dropdown = document.querySelector('.support-menu-dropdown');
      if (
        !supportMenuRef.current?.contains(event.target) &&
        !dropdown?.contains(event.target)
      ) {
        setSupportMenuOpen(false);
      }
    };
    if (supportMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      if (closeTimerRef.current) {
        clearTimeout(closeTimerRef.current);
        closeTimerRef.current = null;
      }
    };
  }, [supportMenuOpen]);

  // ロゴクリック時にトップページへ遷移
  const handleLogoClick = () => {
    switch (userType) {
      case 'admin':
        navigate('/admin/agency/search');
        break;
      case 'agency': {
        const agencyId = userInfo.agency_id;
        if (agencyId) {
          navigate(`/agency/detail/${agencyId}`, {
            state: { initialTab: 'info' }
          });
        } else {
          navigate('/');
        }
        break;
      }
      case 'solicitor':
        navigate('/solicitor/insurance/system/search');
        break;
      default:
        navigate('/');
    }
  };

  const toggleMenu = () => {
    const newMenuState = !menuOpen;
    setMenuOpen(newMenuState);
    onMenuToggle?.(newMenuState);
  };

  // ユーザータイプに基づいて表示するテキストを決定
  const getUserTypeText = () => {
    switch(userType) {
      case 'admin':
        return 'ー IRRC管理者 ー';
      case 'agency':
        return 'ー 代理店管理者 ー';
      case 'solicitor':
        return ' ';
      default:
        return '';
    }
  };

  const handleLogout = async () => {
    await logout();
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    navigate(`/`);
  };
  // サポートリンク
  const supportLinks = [
    {
      label: '利用規約',
      url: 'https://hs.irrc.co.jp/asfinder/useragreement.pdf'
    },
    {
      label: '掲載文書一覧',
      url: 'https://hs.irrc.co.jp/asfinder/list.pdf'
    },
    {
      label: 'マニュアル',
      url: 'https://go.irrc.co.jp/asfinder_manual'
    }
  ];
  // サポートメニュー制御
  const toggleSupportMenu = () => {
    setSupportMenuOpen(!supportMenuOpen);
  };
  const handleMouseEnter = () => {
    if (window.innerWidth > MOBILE_BREAKPOINT) {
      // タイマーをクリア
      if (closeTimerRef.current) {
        clearTimeout(closeTimerRef.current);
        closeTimerRef.current = null;
      }
      setSupportMenuOpen(true);
    }
  };
  const handleMouseLeave = (event) => {
    if (window.innerWidth > MOBILE_BREAKPOINT) {
      // イベントが存在する場合のみ relatedTarget をチェック
      if (event && event.relatedTarget) {
        const relatedTarget = event.relatedTarget;
        // サポートメニュー内の要素に移動する場合は何もしない
        if (relatedTarget && (
          supportMenuRef.current?.contains(relatedTarget) ||
          relatedTarget.closest('.support-menu-dropdown')
        )) {
          return;
        }
      }
      if (closeTimerRef.current) {
        clearTimeout(closeTimerRef.current);
      }
      closeTimerRef.current = setTimeout(() => {
        setSupportMenuOpen(false);
      }, MENU_CLOSE_DELAY);
    }
  };

  return (
    <div className={`header-container ${menuOpen ? 'menu-open' : ''}`}>
      <header className="app-header">
        <div className="header-left">
          <button 
            className={`menu-button ${menuOpen ? 'open' : ''}`} 
            onClick={toggleMenu} 
            aria-label="メニューを開く"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <div 
            className="header-logo" 
            onClick={handleLogoClick} 
            style={{ cursor: 'pointer' }}
          >
            <div className='header-logo-box'>
              <img src={asLogoWhite} alt="IRC 株式会社アイリックコーポレーション" />
              <span className='header-logo-box-text'>{getUserTypeText()}</span>
            </div>
          </div>
        </div>
        <div className="header-right">
          {/* サポートドロップダウンメニュー */}
          {userType === 'solicitor' && (
            <div 
              className="support-menu-container" 
              ref={supportMenuRef}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <button
                className="support-menu-button"
                onClick={toggleSupportMenu}
                aria-expanded={supportMenuOpen}
                aria-haspopup="true"
                aria-label="サポートメニュー"
              >
                <img 
                  src={supportIcon} 
                  alt=""
                  aria-hidden="true"
                  className={`support-menu-icon ${supportMenuOpen ? 'open' : ''}`}
                />
                メニュー
              </button>
              {supportMenuOpen && supportMenuRef.current && ReactDOM.createPortal(
                <div 
                  className="support-menu-dropdown"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  style={{
                    position: 'fixed',
                    top: supportMenuRef.current.getBoundingClientRect().bottom + 4,
                    right: window.innerWidth - supportMenuRef.current.getBoundingClientRect().right
                  }}
                >
                  {/* モバイル用の閉じるボタン */}
                  {window.innerWidth <= MOBILE_BREAKPOINT && (
                    <button
                      className="support-menu-close"
                      onClick={() => setSupportMenuOpen(false)}
                      aria-label="メニューを閉じる"
                    >
                      ×
                    </button>
                  )}
                  {supportLinks.map((link, index) => (
                    <a
                      key={index}
                      href={link.url}
                      className="support-menu-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => setSupportMenuOpen(false)}
                    >
                      {link.label}
                    </a>
                  ))}
                </div>,
                document.body
              )}
            </div>
          )}
          <button className="logout-button" onClick={handleLogout}>ログアウト</button>
        </div>
      </header>

      <div className={`sidebar-menu ${menuOpen ? 'open' : ''}`}>
        <ul>
          {menuItems.map((item, index) => (
            <li 
              key={index} 
              onClick={() => {
                if (item.path) {
                  navigate(item.path);
                }
                if (item.onClick) {
                  item.onClick();
                }
                // メニュー項目をクリックしたらメニューを閉じる
                setMenuOpen(false);
              }}
            >
              {item.label}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Header;
